<template>
  <div class="px-4 py-2 bg-white shadow relative z-20">
    <div class="w-full max-w-7xl flex items-center justify-between mx-auto">
      <router-link :to="{ name: 'options' }">
        <base-logo alt="Real Grupo Cultural Covadonga, control de accesos" class="max-h-12" />
      </router-link>
      <span class="font-sans uppercase text-slate-600 hidden md:block" v-if="titleVisible">{{ pageTitle }}</span>
      <div class="">
        <div class="flex items-center space-x-2">
          <notifications-button :notifications="notifications" @select="onSelect" />
          <span @click="logout" class="flex items-center justify-center transition-all duration-150 w-10 h-10 flex-shrink-0 rounded-full bg-secondary-50 hover:bg-secondary hover:text-white text-secondary cursor-pointer">
            <base-icon name="logout" />
          </span>
          <div ref="avatar" v-outside:click="{ exclude: ['avatar'], handler: closeAvatar }" class="relative dropdown-area cursor-pointer">
            <base-avatar :src="image" :letter="firstLetterName" :isOpen="isOpenAvatar" @toggleAvatar="toggleAvatar" />
            <base-drop-down
              :isOpen="isOpenAvatar"
              position="top-right"
              customClass="whitespace-nowrap"
              @toggle="toggleAvatar"
            >
              <div class="leading-tight p-4 text-gray-900">
                <div class="flex items-center">
                  <base-icon name="user" size="lg" custom="flex-shrink-0"></base-icon>
                  <div class="w-full overflow-hidden ml-4">
                    <span class="text-sm text-gray-700">{{ membership }}</span>
                    <p class="truncate"><strong>{{ name }}</strong> {{ surname }}</p>
                    <p class="truncate">{{ email }}</p>
                  </div>
                </div>
              </div>
            </base-drop-down>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center h-7 md:hidden py-2">
      <span v-if="titleVisible" class="font-sans uppercase text-slate-600">{{ pageTitle }}</span>
    </div>
    <base-modal v-model="open">
      <template v-slot:title>Solicitud de autorización</template>
      <p><strong>{{ notification | name }}</strong>, socio/a menor de edad, ha configurado el sistema de <strong>reconocimiento facial</strong> para el acceso a las instalaciones. Este proceso necesita de su autorización expresa para su activación.</p>
      <p class="mt-3">¿Autoriza dicho proceso?</p>
      <template v-slot:actions>
        <base-button mode="secondary-phantom" text="Cancelar" @click="cancel" />
        <base-button mode="primary" text="Autorizar" :loading="loading" @click="authorize" />
      </template>
    </base-modal>
  </div>
</template>

<script>
import NotificationsButton from '@/components/NotificationsButton.vue'
import BiometricServices from '@/services/biometrics'

export default {
  components: { NotificationsButton },
  name: 'GlobalHeader',
  props: {
    titleVisible: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      open: false,
      notification: null,
      loading: false,
      isOpenAvatar: false
    }
  },
  computed: {
    image: function () {
      return this.$store.getters['auth/image']
    },
    firstLetterName: function () {
      return this.$store.getters['auth/firstLetterName']
    },
    notifications: function () {
      return this.$store.getters['auth/notifications']
    },
    membership: function () {
      return this.$store.getters['auth/membership']
    },
    user: function () {
      return this.$store.getters['auth/user']
    },
    name: function () {
      return this.user ? this.user.nombre : null
    },
    surname: function () {
      return this.user ? this.user.apellidos : null
    },
    email: function () {
      return this.user ? this.user.email : null
    },
    userOptions: function () {
      if (!this.user) {
        return []
      }
      return [
        {
          name: this.user.nombre + ' ' + this.user.apellidos,
          path: ''
        },
        {
          name: this.membership,
          path: ''
        },
        {
          name: this.user.email,
          path: ''
        }
      ]
    }
  },
  methods: {
    logout: function (path) {
      this.$store.dispatch('auth/logout')
    },
    onSelect: function (item) {
      if (item.membership) {
        this.notification = item
        this.open = true
      } else {
        if (this.$route.name !== 'biometric-config') {
          this.$router.push({ name: 'biometric-config' })
        }
      }
    },
    authorize: async function () {
      try {
        this.loading = true
        await BiometricServices.approveChild(this.membership, this.notification.membership)
        this.$store.commit('auth/approveChild', this.notification.membership)
        this.open = false
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    cancel: function () {
      this.open = false
    },
    toggleAvatar: function () {
      this.isOpenAvatar = !this.isOpenAvatar
    },
    closeAvatar: function () {
      this.isOpenAvatar = false
    }
  },
  filters: {
    name: function (notification) {
      return notification ? notification.name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
